import { render, staticRenderFns } from "./pri-creation.vue?vue&type=template&id=1296f2e4&scoped=true"
import script from "./pri-creation.vue?vue&type=script&lang=js"
export * from "./pri-creation.vue?vue&type=script&lang=js"
import style0 from "./pri-creation.vue?vue&type=style&index=0&id=1296f2e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1296f2e4",
  null
  
)

export default component.exports